import { ENV } from "./env";

// Google Analytics 4 — a SynthOS platform default. Guarded so an empty id is a
// no-op. Loaded once at boot; `track()` sends custom conversion events.
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function initAnalytics() {
  const id = ENV.ga4Id;
  if (!id) return;
  try {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
    window.gtag("js", new Date());
    // Friend invite links carry a private token in the path: report the page
    // as plain /invite so tokens never reach analytics.
    const location = window.location.href.replace(/(\/|%2f)invite(\/|%2f)[^/?#&%]*/gi, "/invite");
    window.gtag("config", id, {
      anonymize_ip: true,
      page_location: location,
      page_referrer: document.referrer.replace(/(\/|%2f)invite(\/|%2f)[^/?#&%]*/gi, "/invite"),
    });
  } catch {
    /* analytics must never break the page */
  }
}

/** Fire a GA4 event. Safe no-op when analytics isn't configured. */
export function track(event: string, params: Record<string, unknown> = {}) {
  try {
    window.gtag?.("event", event, params);
  } catch {
    /* ignore */
  }
}
